/*
* @Author: tengmaoqing
* @Date:   2018-06-23 10:42:59
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-28 11:52:34
*/

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import parse from 'url-parse';
import sha1 from 'sha1';
import qs from 'qs';
import { sync } from 'vuex-router-sync';
import { getLocales, getLanguage } from '@/helper/locales';
import { newHttp, checkLoginStatus } from '@/apis/base';
import { getToken } from '@/helper/loginStatusManger.js';
// import { PLATFORM } from '@/system/const/config';
import * as filters from '@/helper/filters';
import { axiosResponesReport } from '@/helper/apiReport';
import AutoSaveFormForVue from '@/helper/saveForm';
import NoSSR from 'vue-no-ssr';
import 'babel-polyfill';
import { merge } from 'lodash';
import * as CONST from '../const/recycle';
import * as LoginJSFuntions from '@/core/login/login-functions';
import { isBankAbc } from '@/helper/uaCheck';

Vue.config.productionTip = false;
Vue.prototype.Q_CONST = CONST;
Vue.use(VueI18n);
Vue.use(AutoSaveFormForVue);
Vue.component('no-ssr', NoSSR);

let rendered = false;

export {
  Vue
};

export class App {
  constructor (...arg) {
    this.init(...arg);
  }

  init (params) {
    const { router, store, locales, App, filterInterceptor, requestConfig } = params;
    sync(store, router);

    this.initConts();
    this.store = store;
    this.router = router;
    this.i18n = this.initIi8n(locales);
    this.vueApp = this.initApp(App);
    this.addAuthResolveHooks();

    this.computedHttpConfig(requestConfig);
    const httpInstance = newHttp(this.httpConfigObj);
    this.http = httpInstance.http;
    this.httpId = httpInstance.Id;
    this.initHttpConfig();
    if (rendered) {
      return;
    }
    this.installFilters(filterInterceptor);

    rendered = true;
  }

  getRuntimeToken () {
    if (typeof window === 'undefined') {
      return this.store.state.user.loginToken;
    }

    return getToken();
  }

  createUUID () {
    var uuidRegEx = /[xy]/g;
    var uuidReplacer = function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 3) | 8;
      return v.toString(16);
    };
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(uuidRegEx, uuidReplacer)
      .toLowerCase();
    return uuid.replace(/-/g, '');
  }

  initConts () {
    this.LoginPath = '/login';
  }

  installFilters (interceptor) {
    Object.keys(filters).forEach(key => {
      let filter = filters[key];
      if (interceptor) {
        filter = interceptor(key, filter);
      }
      Vue.filter(key, filter);
    });
  }

  toLogin (to, next, isInterfaceFail) {
    const currentPath = this.router.currentRoute.path;
    if (this.LoginPath === currentPath && isInterfaceFail) {
      console.warn('vueAPP：不能在登录页面调用 tologin！');
      return;
    }
    const nextRoute = {
      path: this.LoginPath,
      query: { redirect: to.fullPath }
    };
    if (typeof window !== 'undefined' && isBankAbc()) {
      nextRoute.query.redirect = window.encodeURIComponent(window.encodeURIComponent(to.fullPath));
    }
    const resolvedRoute = this.router.resolve(nextRoute, to);
    const loginFunc = this.store.state.config.LoginJSFuntion;
    // 新hsbh5、新cocoh5多端登录统一收归
    if (this.store.state.config.commonLogin) {
      this.store.dispatch('manyLogin/main', { resolvedRoute, nextRoute, next });
      return;
    }
    // oppo、老hsbh5、老cocoh5
    if (loginFunc && LoginJSFuntions[loginFunc]) {
      LoginJSFuntions[loginFunc](resolvedRoute);
      this.bar && this.bar.finish();
      return;
    }
    next(nextRoute);
  }

  checkLoginStatus () {
    return checkLoginStatus().then(res => {
      if (!res || !res._data || res._data.status !== 1) {
        return Promise.reject(new Error('登录过期!'));
      }
      return true;
    });
  }

  // checkPlaceOrderFreeLogin () {
  //   return getCheckLoginWay().then(res => {
  //     if (res._errCode === '0') {
  //       return (res._data.loginWay === '3') || (res._data.loginWay === '5');
  //     }
  //   });
  // }

  addAuthResolveHooks () {
    const _checkLogin = (to, next) => {
      if (!this.getRuntimeToken()) {
        this.toLogin(to, next);
        return;
      }
      // 有token 远程检查
      this.checkLoginStatus().then(isPass => {
        if (isPass) {
          // next();
          this.autoLocateFn(to, next);
        }
      }).catch(() => {
        this.toLogin(to, next);
      });
    };
    const routeNeedLogin = record => {
      if (typeof record.meta.requiresAuth === 'function') {
        return record.meta.requiresAuth(this.store, this.router, this.vueApp);
      }
      return record.meta.requiresAuth;
    };

    this.router.beforeResolve((to, from, next) => {
      if (to.matched.some(routeNeedLogin)) {
        _checkLogin(to, next);
        return;
      }
      // next();
      this.autoLocateFn(to, next);
    });
  }
  autoLocateFn (to, next) {
    const routeNeedLocate = route => {
      return route.meta.autoLocateNeeded;
    };
    // 是否进行定位
    let info = this.store.state.autoLocate && this.store.state.autoLocate.info;
    if (to.matched.some(routeNeedLocate) && !info) {
      this.vueApp.$store.dispatch('autoLocate/initLocate');
    }
    next();
  }

  createApiSign (queryInfo, body) {
    const signIgnoreKeys = ['images'].concat(this.signIgnoreKeys);

    const data = Object.assign({}, queryInfo, body);
    const keyArr = Object.keys(data).sort();
    const kv = [];
    for (let i = 0; i < keyArr.length; i++) {
      if (data.hasOwnProperty(keyArr[i])) {
        if (data[keyArr[i]] === undefined) {
          continue;
        }
        // 跳过不参与签名key
        if (signIgnoreKeys.includes(keyArr[i])) {
          continue;
        }
        kv.push(keyArr[i] + data[keyArr[i]]);
      }
    }
    let signStr = kv.join('');
    signStr = `${signStr}${this.store.state.config.appSecret}`;
    return sha1(signStr).toLowerCase();
  }

  getUTCTimeStamp () {
    const GMTStamp = new Date();
    if (this.store.state.config.isUseBJTime) {
      return GMTStamp.getTime();
    }
    return GMTStamp.getTime() + GMTStamp.getTimezoneOffset() * 60 * 1000;
  }

  httpRequestInterceptor () {
    // 加工请求数据
    this.http.interceptors.request.use(config => {
      const urlObj = parse(config.url, true);
      const addDataToUrl = (key, readyValue = '') => {
        /*
         * @desc: 由于UC浏览器post请求会把query上为空的参数过滤掉，导致验签失败
         * @desc: 暂时过滤掉可能为空的token和appkey，不参与签名
         * @desc: 只过滤token和appkey是因为有些业务参数在后端是必传的，哪怕为空
        */
        if (['token', 'appkey'].includes(key) && !readyValue) return;
        if (!urlObj.query[key]) {
          urlObj.query[key] = readyValue;
          config.url = urlObj.toString();
        }
      };

      addDataToUrl('pid', this.store.state.pid);
      addDataToUrl('token', this.getRuntimeToken());
      /**
       * 某些接口和platform的设计冲突
       * 需要上层写死
       */
      if (!urlObj.platform) {
        addDataToUrl('platform', this.store.state.config.platform);
      }
      addDataToUrl('appkey', this.store.state.config.appkey);
      addDataToUrl('timestamp', parseInt(this.getUTCTimeStamp() / 1000));
      if (this.store.state.uuid) {
        addDataToUrl('uuid', this.store.state.uuid);
      }

      addDataToUrl('ukey', this.createUUID());

      if (this.httpConfigObj.trunks) {
        Object.keys(this.httpConfigObj.trunks).forEach(trunk => {
          addDataToUrl(trunk, this.httpConfigObj.trunks[trunk]);
        });
      }

      addDataToUrl('sign', this.createApiSign(urlObj.query, config.data));
      if (typeof FormData !== 'undefined' && !(config.data instanceof FormData)) {
        config.data = qs.stringify(config.data);
      }
      config.startTime = +new Date();
      if (this.httpConfigObj.onRequest) {
        this.httpConfigObj.onRequest(config);
      }
      return config;
    });
  }

  httpResponseDataAdjust () {
    //  简化响应数据
    this.http.interceptors.response.use(response => {
      const result = response.data;
      if (+result._errCode === 0) {
        result.success = true;
      } else {
        result.success = false;
      }
      return Promise.resolve(response);
    });
  }

  httpResponseErrorHandler () {
    this.http.interceptors.response.use(response => {
      if (this.httpConfigObj.onEnd) {
        this.httpConfigObj.onEnd(response);
      }
      return new Promise((resolve, reject) => {
        const result = response.data;
        if (!this.httpConfigObj.checkResult) {
          resolve(result);
          return;
        }
        if (this.httpConfigObj.checkResult(result)) {
          resolve(result);
        }
        reject(new Error('验证未通过'));
      });
    }, (err) => {
      if (this.httpConfigObj.onEnd) {
        this.httpConfigObj.onEnd(err);
      }
      return Promise.reject(err);
    });
  }

  computedHttpConfig (requestConfig) {
    this.httpConfigObj = merge({
      apiHost: this.store.state.apiHost,
      trunks: {
        version: 1
      },
      checkResult: (result) => {
        if (result._errCode === '200000') {
          this.store.commit('user/authFail');
          this.toLogin(this.router.currentRoute, this.router.push.bind(this.router), true);
          return false;
        }
        return true;
      },
      onEnd: axiosResponesReport
    }, requestConfig);
  }

  initHttpConfig () {
    this.httpRequestInterceptor();
    this.httpResponseDataAdjust();
    this.httpResponseErrorHandler();
  }

  initApp (App) {
    return new Vue({
      router: this.router,
      store: this.store,
      i18n: this.i18n,
      render: h => h(App)
    });
  }

  initIi8n (locales, serverStore) {
    const messages = getLocales(locales);
    const store = serverStore || this.store;
    return new VueI18n({
      locale: store.state.language || getLanguage(messages),
      messages
    });
  }
};



// WEBPACK FOOTER //
// ./src/system/init/init-vue-app.js